module.exports = __webpack_public_path__ + "dotnet.925f9a.svg";